 

import Vue from 'vue'
import { Component } from 'vue-property-decorator'
import { MasterTemplate } from '@appbase/templates/'
import GnbLeftView from '@gnb/views/GnbLeft/GnbLeftView.vue'

@Component({
  components: { MasterTemplate, GnbLeftView },
})
export default class SurveyMaster extends Vue {
    
}
